import { getUserAgentInfo } from "./user-agent-info";
import browser from "webextension-polyfill";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
async function getExperimentsAssignments() {
    const assignments = await ewe.experiments.getAssignments();
    return Object.entries(assignments).map(([experimentId, variantId]) => ({
        experimentId,
        variantId,
    }));
}
async function getExperimentData() {
    const experimentFlags = await ewe.experiments.getFlags();
    const experimentAssignments = await getExperimentsAssignments();
    return { experimentFlags, experimentAssignments };
}
async function getDebugAlarmInfo() {
    const alarms = await browser.alarms.getAll();
    const alarmInfo = alarms.map((alarm) => ({
        name: alarm.name,
        time: new Date(alarm.scheduledTime).toLocaleString(),
    }));
    return alarmInfo;
}
async function getSubscriptionInfo() {
    const subscriptions = await ewe.subscriptions.getSubscriptions();
    const response = subscriptions.map((sub) => {
        var _a, _b;
        const subscription = {
            enabled: sub.enabled,
            title: sub.title,
            id: sub.id,
            lastSuccess: sub.lastSuccess
                ? new Date(sub.lastSuccess).toLocaleString()
                : "unknown",
            lastDownload: sub.lastDownload
                ? new Date(sub.lastDownload).toLocaleString()
                : "unknown",
            downloadStatus: (_a = sub.downloadStatus) !== null && _a !== void 0 ? _a : "unknown",
            downloadCount: (_b = sub.downloadCount) !== null && _b !== void 0 ? _b : -1,
        };
        return subscription;
    });
    return response;
}
async function getCustomFilterMetaData() {
    const currentUserFilters = await ewe.filters.getUserFilters();
    if (!currentUserFilters.length) {
        return [];
    }
    const validRules = currentUserFilters.filter((rule) => rule === null || rule === void 0 ? void 0 : rule.text);
    return await Promise.all(validRules.map(async (filter) => {
        const metadata = await ewe.filters.getMetadata(filter.text);
        return metadata
            ? { ruleText: filter.text, metadata }
            : { ruleText: filter.text };
    }));
}
async function getJavascriptErrors() {
    var _a;
    const errorKey = "errorkey";
    const error = await browser.storage.local.get(errorKey);
    return (_a = error[errorKey]) !== null && _a !== void 0 ? _a : "no JS error";
}
async function getMigrationMessages() {
    const [filtersErrors, subscriptionsErrors] = await Promise.all([
        ewe.filters.getMigrationErrors(),
        ewe.subscriptions.getMigrationErrors(),
    ]);
    return {
        filtersErrors,
        subscriptionsErrors,
    };
}
export async function getDebugInformation(parameters) {
    const [alarmInformation, errors, hostPermissions, migrationErrors, remoteConfigurationInformation, subscriptions, userFilters,] = await Promise.all([
        getDebugAlarmInfo(),
        getJavascriptErrors(),
        browser.permissions.getAll(),
        getMigrationMessages(),
        getExperimentData(),
        getSubscriptionInfo(),
        getCustomFilterMetaData(),
    ]);
    const response = {
        deviceSpecificInformation: {
            alarmInformation,
            remoteConfigurationInformation,
            subscriptions,
            userFilters,
        },
        errors,
        extensionInformation: {
            extensionVersion: browser.runtime.getManifest().version,
            extensionID: browser.runtime.id,
            hostPermissions,
        },
        hostSpecificInformation: parameters,
        migrationErrors,
        platformInformation: {
            browserName: getUserAgentInfo().browserName,
            browserVersion: getUserAgentInfo().browserVersion,
            manifestVersion: browser.runtime.getManifest().manifest_version,
            osVersion: getUserAgentInfo().osVersion,
            os: getUserAgentInfo().os,
        },
    };
    return response;
}
